import * as moment from 'moment';

import { MSEvent } from './ms_event.dto';

// utilizado para visualização do evento
export class PrimeFaceScheduleEvent {
  // required
  date: Date | moment.Moment;
  title: string;
  
  // optional
  description?: string;
  borderColor?: string;
  backgroundColor?: string;

  // sut
  startDate?: any;
  endDate?: any;

  // nt
  id?: string;
  url?: string;
  data?: any;
  allDay?: boolean;
  editable?: boolean;
  styleClass?: string;
  renderingMode?: 'background' | 'inverse-background';

  dynamicProperties?: any;

  // is not from prime
  calendar_id?: any;

  static getCalendarId(dto): string {
    const value = dto['calendar@odata.associationLink'] || dto['@odata.context'] || '';
    const match = value.match(/calendars\('([^']+)'\)/);
    return match ? match[1] : '';
  }

  static format(dto: MSEvent) {

    const instance = new PrimeFaceScheduleEvent();

    instance.title = dto.subject;

    instance.date = moment(dto.start.dateTime);
    instance.endDate = moment(dto.end.dateTime);
    instance.startDate = moment(dto.start.dateTime);

    // need implementation
    instance.dynamicProperties = dto.categories;

    // not required yet
    // instance.recurrence = dto.recurrence;

    // from ms
    instance.id = dto.id;
    // instance.url = dto.webLink;
    instance.title = dto.subject;
    instance.allDay = dto.isAllDay;
    instance.description = dto.bodyPreview;

    return instance;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/ms_scheduling_primeface.ts